import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'gen-dropdown-with-title',
  templateUrl: './dropdown-with-title.component.html',
  styleUrls: ['./dropdown-with-title.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class DropdownWithTitleComponent implements OnInit {

  @Input() config: {
    title: string;
    tooltip: string,
    signAsRequired: boolean
    options: { display: string; code: string; }[]
  };

  @Output() selectedOption: EventEmitter<{ display: string; code: string; }> = new EventEmitter();

  selectControl: FormControl = new FormControl();

  constructor() {
  }

  ngOnInit() {
    this.selectControl.valueChanges.subscribe((value) => {
      this.selectedOption.emit(value);
    });
  }

  trackByFn(item, index) {
    return item ? item.code : index;
  }
}
